import React, { useRef } from "react";
import UserReportTable1 from "../../../components/chart/UserReportTable1";
import UserReportTable from "../../../components/chart/UserReportTable";
import { knf_logo } from "../../../assets/imgs";
import html2pdf from "html2pdf.js";
import moment from "moment/moment";
import "./UserReportPage.css";

const UserReportPage = ({ data }) => {
  const pdfRef = useRef();

  const downloadPDF = () => {
    const element = pdfRef.current;
    const opt = {
      margin: 0,
      filename: `User-Report-${moment(new Date()).format("DD-MM-YYYY")}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const w = pdf.internal.pageSize.getWidth();
        const h = pdf.internal.pageSize.getHeight();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(9);
          pdf.setTextColor(150);
          pdf.text(`Page ${i} of ${totalPages}`, w / 2, h - 10, {
            align: "center",
          });
        }
      })
      .save();
  };

  return (
    <div className=" ">
      <div className="d-flex ac-je">
        <div className="col-md-1 mt-4">
          <button onClick={() => downloadPDF()} className="submit-btn">
            Download
          </button>
        </div>
      </div>

      {/* knf logo */}
      <div ref={pdfRef} className="pdf-container">
        <div className="mt-4 mb-4">
          <div className="image_text1 pointer mt-1">
            <img src={knf_logo} alt="" className="knf-logo" />

            {/* knf User Wise Alert Summary for Tampines */}
            <div className="">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                KNF User Wise Alert Summary for Tampines
              </h2>
            </div>
          </div>

          <table className="info-table">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Site Name</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data?.company || "N/A"}</td>
                <td>{data?.site || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/*  */}
        {/* label n input field */}
        <div className="date-row">
          <div>From: {data?.from_date}</div>
          <div>To: {data?.to_date}</div>
        </div>
        {/*  */}
        <div className="mt-4 col-12 ">
          <p className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2 ">
            Total Site Alerts for the above period - {data?.total_alert_count}
          </p>
        </div>
        <div>
          <UserReportTable data={data} />
        </div>
      </div>
    </div>
  );
};

export default UserReportPage;
